import APIClient from '@/shared/http/clients/apiupload.js'

const resourceName = 'DespesaAnexoLog'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

// Task 046: o back so devolve lote da empresa da tela, e so se a conta pode usar essa empresa.
const GetByName = (name, empresaId, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetByName/${name}/${empresaId}`, data, config)
const GetByLote = (value, empresaId, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetByLote/${value}/${empresaId}`, data, config)
const GetAll = (empresaId, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetAll/${empresaId}`, data, config)

const ExpenseAttachmentLogRepository = {
  GetByName,
  GetByLote,
  GetAll

}

export default ExpenseAttachmentLogRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/expenseattachmentlog.js